import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NVD3Chart from 'react-nvd3';
import * as d3 from 'd3';

import metricsTools from '../../utils/metricsTools';
import hideNVD3Tooltip from '../../utils/hideNVD3Tooltip';


const getBucketIndex = (res, bucketItem) => {
    for (let i = 0; i < res.length; i += 1) {
        if (res[i].key === bucketItem.bucketName) {
            return i;
        }
    }
    return -1;
};

const pushBucketData = (res, bucketItem) => {
    const index = getBucketIndex(res, bucketItem);
    // Account is not yet in the res array
    if (index === -1) {
        const newResItem = {
            key: bucketItem.bucketName,
            values: [
              [bucketItem.timeRange, bucketItem.storageUtilized],
            ],
        };
        res.push(newResItem);
        return res;
    }
    // Account is already in res
    res[index].values
    .push([bucketItem.timeRange, bucketItem.storageUtilized]);
    return res;
};

const trimNullData = data => {
    const res = [];
    for (let i = 0; i < data.length; i += 1) {
        const elementValues = data[i].values;
        let valuesTotal = 0;
        for (let j = 0; j < elementValues.length; j += 1) {
            valuesTotal += elementValues[j][1];
        }
        if (valuesTotal > 0) {
            res.push(data[i]);
        }
    }
    return res;
};


const formatDataForChart = data => {
    const res = [];

    for (let i = 0; i < data.length; i += 1) {
        const timeRangeElement = data[i];

        for (let j = 0; j < timeRangeElement.length; j += 1) {
            const bucketElement = timeRangeElement[j];
            pushBucketData(res, bucketElement);
        }
    }

    return trimNullData(res);
};

const context = {
    formatXAxis: d => d3.time.format('%x')(new Date(d)),
    formatYAxis: d => metricsTools.bytesToSize(d),
};


class StorageHistoryChartComponent extends Component {
    componentWillReceiveProps() {
        hideNVD3Tooltip();
    }

    render() {
        return (
          <div>
            <NVD3Chart
              id="barChart"
              type={this.props.horizontal
                ? 'multiBarHorizontalChart' : 'multiBarChart'}
              datum={formatDataForChart(this.props.data)}
              context={context}
              xAxis={{
                  tickFormat: {
                      name: 'formatXAxis',
                      type: 'function',
                  },
              }}
              yAxis={{
                  tickFormat: {
                      name: 'formatYAxis',
                      type: 'function',
                  },
              }}
              margin={this.props.horizontal
                ? { left: 100 } : { right: 90 }}
              rightAlignYAxis={true}
              clipEdge={false}
              showControls={true}
              showLegend={true}
              stacked={true}
              x={ d => {
                  const date = new Date(d[0]);
                  return date.getTime();
              }}
              y={ d => (d[1])}
              height={this.props.height || (this.props.horizontal ? 850 : 400)}
            />
          </div>
        );
    }
}

StorageHistoryChartComponent.propTypes = {
    horizontal: PropTypes.bool,
    height: PropTypes.number,
    data: PropTypes.array.isRequired,
};

export default StorageHistoryChartComponent;



/** WEBPACK FOOTER **
 ** ./src/components/charts/StorageHistoryChartComponent.js
 **/